<template>
    <div :style="{ minHeight: computedMinHeight }" class="center-content">
      <div v-if="isLoading" class="spinner-grow text-info align-self-center" style="margin-top: -8px !important;"></div>
      <center>&nbsp; <v-slot><label>{{ title }}</label></v-slot></center>
    </div>
  </template>
  
  <script setup>
  import { defineProps, computed } from 'vue';
  
  const props = defineProps({
    isLoading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Loading Data...',
    },
    minHeight: {
      type: String,
      default: '400px',
    },
  });
  
  const computedMinHeight = computed(() => {
    // Check if a prop named 'minHeight' is provided, and if not, use the default value of 400px.
    return props.minHeight || '400px';
  });
  </script>
  
  <style scoped>
  .center-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100% !important;
    width: 100% !important;
  }
  </style>
  